import React, { useState, useEffect } from "react";
import { Box, Grid, Divider } from "@mui/material";
import { H3, H4, H5 } from "../../components/Typography";
import { load, remove } from "../../constants/storage";
import { goldsilverTransaction } from "../../redux/actions/TransactionAction";
import { toast } from "react-hot-toast";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";

export default function GoldSilverTransaction() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [goldData, setGoldData] = React.useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getGSTransaction();
    }
  };

  const getGSTransaction = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    const countryCode: any = "91";
    let finalUser = JSON.parse(userDetail);
    var numberWithCode = countryCode + finalUser.mobile;
    const values = {
      phoneNumber: numberWithCode,
      selectedItem: "All",
    };

    dispatch(goldsilverTransaction(values, token))
      .then(async (response: any) => {
        if (response?.statusCode === 401) {
          return;
        }
        if (response?.statusCode === 200) {
          setGoldData(response.txnList);
        }
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };
  const convertTimeDate = (value: any) => {
    if (value == null) {
      return "--";
    } else {
      let date = new Date(value);
      let transactionDate = moment(date).format("DD MMM YYYY hh:mm A");

      return transactionDate;
    }
  };
  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : goldData?.length === 0 || goldData === undefined ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <H3>No record found!</H3>
        </Grid>
      ) : (
        <Grid
          textAlign="center"
          justifyContent="center"
          height="100vh"
          sx={{ background: "#fff" }}
        >
          <Grid>
            {goldData.map((item: any, index: any) => (
              <>
                <Grid
                  onClick={() =>
                    navigate("/transactiondetail", {
                      state: {
                        data: item,
                        screenname: "goldsilver",
                        status:
                          item.status === "TXN_SUCCESS"
                            ? "Success"
                            : item.status === "TXN_FAILURE"
                            ? "Failed"
                            : item.status === "INITIATED"
                            ? "Failed"
                            : item.status === "Executed" &&
                              item.txnType === "Redeemed"
                            ? "Success"
                            : item.status === "INITIATED" &&
                              item.txnType === "Redeemed"
                            ? "Failed"
                            : item.status === "Executed" &&
                              item.txnType === "Sell"
                            ? "Success"
                            : "In Progress",
                      },
                    })
                  }
                  justifyContent="space-between"
                  sx={{ display: "flex", cursor: "pointer" }}
                >
                  {/* 1st */}
                  <Box
                    sx={{
                      display: "flex",
                      mt: 1,
                      p: { xs: 0.5, sm: 1, md: 1 },
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        item?.productId === "gold"
                          ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                          : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                      }
                      sx={sxStyleImage}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginLeft: { xs: 0.5, sm: 1, md: 1.5 },
                      }}
                    >
                      <H4 fontWeight={500} color="#141414" sx={text}>
                        {item?.productId === "gold" ? "Gold" : "Silver"}
                      </H4>

                      <Grid
                        alignItems="center"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <H5
                          color="#747474"
                          fontWeight={"400"}
                          sx={{
                            mr: {
                              md: 1,
                              xs: 0,
                            },
                            fontSize: {
                              md: 14,
                              xs: 10,
                              sm: 14,
                            },
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.orderId.includes("SELL")
                            ? "Sold"
                            : item.orderId.includes("SELF")
                            ? "Invested"
                            : item.orderId.includes("COIN")
                            ? "Coin Purchased"
                            : item.orderId.includes("REDEEM")
                            ? "Redeemed"
                            : item.orderId.includes("POTS")
                            ? "Goal"
                            : "Gift sent"}
                        </H5>
                        <H5
                          color="#747474"
                          fontWeight={"400"}
                          sx={{
                            ml: 1,
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: {
                              md: 14,
                              xs: 10,
                              sm: 14,
                            },
                          }}
                        >
                          {convertTimeDate(item?.transactionTime)}
                        </H5>
                      </Grid>
                    </Box>
                  </Box>
                  {/* 2 nd */}
                  <Box
                    sx={{
                      display: "flex",
                      mt: 1,
                      p: { xs: 1, sm: 1, md: 1 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        mr: {
                          md: 1,
                          xs: 1,
                        },
                      }}
                    >
                      <H4 fontWeight={600} color="#012876">
                        ₹{item?.amount}
                      </H4>

                      <H5
                        color={
                          item?.status === "TXN_SUCCESS"
                            ? "#45A35F"
                            : item?.status === "TXN_FAILURE"
                            ? "#FF0000"
                            : item?.status === "INITIATED"
                            ? "#FF0000"
                            : item?.status === "Executed" &&
                              item?.txnType === "Redeemed"
                            ? "#45A35F"
                            : item?.status === "INITIATED" &&
                              item?.txnType === "Redeemed"
                            ? "#FF0000"
                            : item?.status === "Executed" &&
                              item?.txnType === "Sell"
                            ? "#45A35F"
                            : "#FF9300"
                        }
                        fontWeight={"400"}
                        sx={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {item?.status === "TXN_SUCCESS"
                          ? "Success"
                          : item?.status === "TXN_FAILURE"
                          ? "Failed"
                          : item?.status === "INITIATED"
                          ? "Failed"
                          : item?.status === "Executed" &&
                            item?.txnType === "Redeemed"
                          ? "Success"
                          : item?.status === "INITIATED" &&
                            item?.txnType === "Redeemed"
                          ? "Failed"
                          : item?.status === "Executed" &&
                            item?.txnType === "Sell"
                          ? "Success"
                          : "In Progress"}
                      </H5>
                    </Box>
                  </Box>
                </Grid>
                <Divider />
              </>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
}

const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
  fontWeight: "600",
};
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 40,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};
